import treasureChestImage from 'src/images/pngs/campaigns/hack2win-flash-sale/treasure-chest.png';
import leftRays from 'src/images/svgs/campaigns/hack2win-flash-sale/left-rays.svg';
import leftStars from 'src/images/svgs/campaigns/hack2win-flash-sale/left-stars.svg';
import rightStars from 'src/images/svgs/campaigns/hack2win-flash-sale/right-stars.svg';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const StyledBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-basis: 8.1rem;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;
  z-index: 0;
  overflow: hidden;
  position: relative;

  flex-direction: row;
  padding: 1.2rem 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 2.4rem;
    flex-direction: column;
  }

  @media screen and (max-width: 576px) {
    flex-direction: column;
    padding: 2.4rem 1.2rem;
  }

  background: linear-gradient(91deg, rgba(28, 37, 56, 1) 64%, rgba(61, 99, 174, 1) 100%);

  & > * {
    z-index: 10;
  }
`;

export const StyledBarAlt = styled(StyledBar)`
  flex-wrap: nowrap;
  flex-direction: row;
  gap: 0;
`;

export const StyledText = styled.p`
  font-size: 2.2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: 2.5rem;
  letter-spacing: -0.64px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey[100]};

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

export const StyledTextAlt = styled(StyledText)`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  letter-spacing: normal;

  text-align: center;

  a {
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    text-align: left;
  }

  @media screen and (max-width: 1200px) {
    max-width: 53rem;
  }
`;

export const StyledTitle = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledWrapRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`;

const BackgroundImage = styled.div`
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 1;
`;

export const LeftStars = styled(BackgroundImage)`
  background-image: url(${leftStars});
  width: 330px;
  height: 141.3px;
  left: 31px;
  top: -78px;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    left: -15px;
    top: 3px;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    left: 0;
    top: 45px;
  }
`;

export const RightStars = styled(BackgroundImage)`
  background-image: url(${rightStars});
  width: 330px;
  height: 141.3px;
  right: 0;
  top: -82px;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    right: 0;
    top: 2px;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    display: none;
  }
`;

export const LeftRays = styled(BackgroundImage)`
  width: 386.6px;
  height: 194.94px;
  background-image: url(${leftRays});
  left: -72px;
  top: -82px;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    left: 0;
    top: -25px;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    left: -102px;
    top: 18px;
  }
`;

export const StyledImageWrapRow = styled(StyledWrapRow)`
  width: 26rem;
  position: relative;
  display: flex;

  @media screen and (max-width: 576px) {
    display: none;
  }
`;

export const StyledTreasureChestImg = styled.img.attrs({
  src: treasureChestImage,
  alt: 'Crown',
})`
  position: absolute;
  z-index: 1;
  width: 100%;
`;
